import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import docsImage from './../../images/docs.png'
import './Decsription.css'
import toast from 'react-hot-toast';
import { updateInfo } from '../../service/customerService';

const DecsriptionModal = ({ showModal, handleClose, customer, admin, setNewInfo }) => {

    const [info, setInfo] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!showModal && (info)) {
            setInfo('');
        }
        else if (showModal) {
            setInfo(customer.info || '')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal])

    const storInfoHandler = async (event) => {
        event.preventDefault();
        try {

            const params = {
                companyName: customer.companyName,
                info: info,
            }
            setIsLoading(true);
            const { status } = await updateInfo(params);
            if (status === 201) {
                setNewInfo(customer.companyName, info)
                toast.success('عملیات با موفقیت انجام شد')
                handleClose();
            }

        } catch (err) {
            if (err.response && err.response.status === 404) {
                toast.error('کاربر یافت نشد')
            }
            else{
                toast.error('خطایی رخ داده است')
            }
        }
        setIsLoading(false)
    };



    return (
        <Modal
            size="lg"
            show={showModal}
            onHide={handleClose}
            aria-labelledby="example22-modal-sizes-title-sm"
            backdrop="static"
            className='info-modal-layer'
        >
            <Modal.Header>
                <Modal.Title id="license2-modal-sizes-title-sm" className='rtl d-flex align-items-center ml-auto'>
                    <img src={docsImage} alt="" style={{ width: "40px", marginLeft: '10px' }} />
                    توضیحات تکمیلی
                </Modal.Title>
            </Modal.Header>
            {
                customer &&
                <Modal.Body className='rtl'>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea12">
                        <Form.Label>توضیحات</Form.Label>
                        <Form.Control
                            as="textarea"
                            style={{ height: '45vh', fontSize: '.8rem' }}
                            value={info}
                            onChange={e => setInfo(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
            }
            <Modal.Footer>
                <Button variant="secondary w-25" onClick={handleClose} disabled={isLoading}>
                    لغو
                </Button>
                <Button variant="success w-25" disabled={!info || isLoading} onClick={storInfoHandler}>
                    ذخیره
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DecsriptionModal;